import lscache from "lscache";

import {getPhoneVerificationCodeRemainingTime, PHONE_VERIFICATION_CODE_SENT_LS_KEY, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "@pg-mono/user";

export type SmsCodeCooldownKind = "profile" | "smsLogin";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "registrationWizardSmsLogin";

const getCooldownKeys = (kind: SmsCodeCooldownKind) =>
    kind === "smsLogin"
        ? {
              timerStart: `${SMS_LOGIN_STORAGE_KEY_NAMESPACE}:${PHONE_VERIFICATION_TIMER_START_LS_KEY}`,
              codeSent: `${SMS_LOGIN_STORAGE_KEY_NAMESPACE}:${PHONE_VERIFICATION_CODE_SENT_LS_KEY}`
          }
        : {timerStart: PHONE_VERIFICATION_TIMER_START_LS_KEY, codeSent: PHONE_VERIFICATION_CODE_SENT_LS_KEY};

export const getSmsCodeCooldownStart = (kind: SmsCodeCooldownKind): number | null => {
    const startTime = lscache.get(getCooldownKeys(kind).timerStart);

    return startTime ? parseInt(startTime, 10) : null;
};

export const getSmsCodeCooldownRemainingSeconds = (kind: SmsCodeCooldownKind) => getPhoneVerificationCodeRemainingTime(getSmsCodeCooldownStart(kind));

export const startSmsCodeCooldown = (kind: SmsCodeCooldownKind) => {
    const keys = getCooldownKeys(kind);
    const startTime = Date.now();

    lscache.set(keys.timerStart, startTime.toString());
    lscache.set(keys.codeSent, "1");

    return startTime;
};

export const clearSmsCodeCooldown = (kind: SmsCodeCooldownKind) => {
    const keys = getCooldownKeys(kind);

    lscache.remove(keys.timerStart);
    lscache.remove(keys.codeSent);
};
import lscache from "lscache";

import {getPhoneVerificationCodeRemainingTime, PHONE_VERIFICATION_CODE_SENT_LS_KEY, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "@pg-mono/user";

export type SmsCodeCooldownKind = "profile" | "smsLogin";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "registrationWizardSmsLogin";

const getCooldownKeys = (kind: SmsCodeCooldownKind) =>
    kind === "smsLogin"
        ? {
              timerStart: `${SMS_LOGIN_STORAGE_KEY_NAMESPACE}:${PHONE_VERIFICATION_TIMER_START_LS_KEY}`,
              codeSent: `${SMS_LOGIN_STORAGE_KEY_NAMESPACE}:${PHONE_VERIFICATION_CODE_SENT_LS_KEY}`
          }
        : {timerStart: PHONE_VERIFICATION_TIMER_START_LS_KEY, codeSent: PHONE_VERIFICATION_CODE_SENT_LS_KEY};

export const getSmsCodeCooldownStart = (kind: SmsCodeCooldownKind): number | null => {
    const startTime = lscache.get(getCooldownKeys(kind).timerStart);

    return startTime ? parseInt(startTime, 10) : null;
};

export const getSmsCodeCooldownRemainingSeconds = (kind: SmsCodeCooldownKind) => getPhoneVerificationCodeRemainingTime(getSmsCodeCooldownStart(kind));

export const startSmsCodeCooldown = (kind: SmsCodeCooldownKind) => {
    const keys = getCooldownKeys(kind);
    const startTime = Date.now();

    lscache.set(keys.timerStart, startTime.toString());
    lscache.set(keys.codeSent, "1");

    return startTime;
};

export const clearSmsCodeCooldown = (kind: SmsCodeCooldownKind) => {
    const keys = getCooldownKeys(kind);

    lscache.remove(keys.timerStart);
    lscache.remove(keys.codeSent);
};
